import React from 'react'
import { TimePicker } from '@progress/kendo-react-dateinputs'
import { Popup } from "@progress/kendo-react-popup"
import styles from "./TimePickerGD.module.css"
import TooltipHLPure from '../tooltipHL/tooltipHL.pure'
import "./TimePickerGD.module.css"

/** 
 * @callback onChange
 * @param {import("@progress/kendo-react-dateinputs").TimePickerChangeEvent} event
 * @returns {void}
*/

/** 
 * @callback onBlur
 * @param {React.FocusEvent<HTMLDivElement>} event
 * @returns {void}
*/

/**
 * @typedef {object} Props
 * @property {string} textLabel
 * @property {boolean} [tooltipShow]
 * @property {"right" | "left" | "top" | "bottom"} [positionTooltip]
 * @property {string} [titleTooltip]
 * @property {string} [descriptionTooltip]
 * @property {string} [subContent]
 * @property {string} [restContent]
 * @property {string} [informationIcon]
 * @property {Date} timeState
 * @property {string} [format]
 * @property {Date} [min]
 * @property {Date} [max]
 * @property {onChange} onChange
 * @property {onBlur} onBlur
 * @property {boolean} [disabled]
 * @property {boolean} [errorInput]
 * @property {string} [errorDatePicker]
 * @property {{hour?: number, minute?: number, second?: number}} [steps]
 */

/**
 * @param {Props}
 */
const TimePickerGD = ({
    textLabel,
    tooltipShow,
    positionTooltip,
    titleTooltip,
    descriptionTooltip,
    subContent,
    restContent,
    informationIcon,
    timeState,
    format,
    min,
    max,
    onChange,
    onBlur,
    disabled,
    errorInput,
    errorDatePicker,
    steps
}) => {
    return (
        <div className={styles["timePicker_container"]}>
            <div className={styles["timePicker-container-text"]}>
                {textLabel &&
                    <label for="date" className={styles["timePicker-label"]}>
                        {textLabel}
                    </label>}
                {tooltipShow &&
                    <TooltipHLPure
                        positionTooltip={positionTooltip}
                        titleTooltip={titleTooltip}
                        descriptionTooltip={descriptionTooltip}
                        subContent={subContent}
                        restContent={restContent}
                        informationIcon={informationIcon}
                    />
                }
            </div>
            <TimePicker
                id={"date"}
                name={"date"}
                value={timeState}
                format={format || "hh:mm a"}
                steps={steps}
                min={min}
                max={max}
                popup={(props) => <Popup popupClass={"popup-styles"} {...props} />}
                onChange={onChange}
                onBlur={onBlur}
                className={styles["timePicker-style"]}
                disabled={disabled}
            />
            {errorInput &&
                <div>
                    <span className={styles["hint-message-error"]}>{errorDatePicker}</span>
                </div>
            }
        </div>
    )
}

export default TimePickerGD